import styled from 'styled-components';

export const StyledSwitchButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  > div {
    margin-bottom: 12px;
  }
  .ant-form-item {
    width: 50px;
    min-width: 50px !important;
  }
`;

export const FlexRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  width: 100%;

  > div {
    max-width: 288px;
  }
`;
